<template>
    <div class="topDataBlock">
      <!-- <div class="topData">
          <div class="DataTitle">学院目前资金总预算</div>
          <div class="topData_value">
            <span>{{ data.budget }}</span>
            <span>（千万）</span>
          </div>
        </div>   -->
        <div class="topData">
          <div class="DataTitle">创客项目人数<span style="font-size: 14px;position: relative;top: 5px;">（人）</span></div>
          <div class="topData_value">
            <span>{{ data.people }}</span>
            
          </div>
        </div> 
        <div class="topData">
          <div class="DataTitle">目前积累项目数量</div>
          <div class="topData_value">
            <span>{{ data.project }}</span>
            <span></span>
          </div>
        </div> 
        <div class="topData">
          <div class="DataTitle">目前积累活动数量</div>
          <div class="topData_value">
            <span>{{ data.activity }}</span>
            <span></span>
          </div>
        </div> 
        <div class="topData">
          <div class="DataTitle">已支出预算<span style="font-size: 14px;position: relative;top: 5px;">{{data.isPay<=9999999?'（万）':'（千万）'}}</span></div>
          <div class="topData_value">
            <span v-if="data.isPay<=9999999">{{ Math.floor(data.isPay/10000*100)/100 }}</span>
            <span v-else>{{ Math.floor(data.isPay/10000000*100)/100 }}</span>
            <!-- <span>（万）</span> -->
          </div>
        </div> 
        <!-- <div class="topData">
          <div class="DataTitle">创客项目人数</div>
          <div class="topData_value">
            <span>{{data.people}}</span>
            <span><img src="@/assets/img/upIcon.png"></span>
          </div>
        </div>
        <div class="topData">
          <div class="DataTitle">目前积累创客项目数量</div>
          <div class="topData_value">
            <span>{{ data.project }}</span>
          </div>
        </div>
        <div class="topData">
          <div class="DataTitle">创客活动数量</div>
          <div class="topData_value">
            <span>{{ data.activity }}</span>
          </div>
        </div>
        <div class="topData">
          <div class="DataTitle">已支出预算</div>
          <div class="topData_value">
            <span>{{ data.isPay }}</span>
            <span>（千万）</span>
          </div>
        </div> -->
        
      </div>
</template>

<script>
    export default {
        props:['data']
    }
</script>

<style lang="less" scoped>
  .topDataBlock{
    margin-top: 20px;
    width: 100%;
    height: 130px;
    // background: #b65f5f;
    display: flex;
    // justify-content:space-between;
    // margin-right: 30px;
    justify-content: flex-start;
    align-items: center;
    .topData{
      width: 19%;
      height: 94%;
      margin-right: 2%;
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      // padding: 15px 10px 10px 35px;
      .DataTitle{
        margin: 15px 10px 10px 0px;
        color: white;
        font-size: 18px;
        position: relative;
        box-sizing: border-box;
        padding-left: 35px;
        width: 100%;
        text-overflow: ellipsis;
        display: flex;
        overflow: hidden;
        white-space: nowrap;
        &::after{
          content: '';
          display: block;
          position: absolute;
          width: 7px;
          height: 86%;
          top: 7%;
          left: 23px;
          background-color: white;
        }
      }
      .topData_value{
        width: auto;
        height: 40%;
        margin: 15px 20px 10px 20px;
        display: flex;
        align-items: center;
        color: white;
        span{
          height: 100%;
          display: flex;
          // align-items: flex-end;
        }
        span:nth-of-type(1){
          font-size: 2.8em;
        }
        span:nth-of-type(2){
          align-items: flex-end;
          img{
            height: 32px;
            margin-left: 5px;
          }
        }
      }
    }
    .topData:nth-child(1){
      background-image: linear-gradient(100deg, #3caef5 60%,#497df5);
    }
    .topData:nth-child(2){
      background-image: linear-gradient(100deg, #fcb871 60%,#f77c5f);
    }
    .topData:nth-child(3){
      background-image: linear-gradient(100deg, #3ce0ea 60%,#29bfa3);
    }
    .topData:nth-child(4){
      background-image: linear-gradient(100deg, #3caef5 60%,#497df5);
    }
    .topData:nth-child(5){
      background-image: linear-gradient(100deg, #fcb871 60%,#f77c5f);
    }
  }
</style>